import api from '@/api/incidences'

// getters
const getters = {
}

// actions
const actions = {
  compute ({ commit }, request) {
    return api.compute(request)
  },

  freeze ({ commit }, request) {
    return api.freeze(request)
  }
}

export default {
  namespaced: true,
  getters,
  actions
}
